import { createTheme } from '@mui/material';
import { background, paper, primary, primaryLight } from './colors';

export const theme = createTheme({
  palette: {
    primary: {
      main: primary,
      light: primaryLight,
    },
    background: {
      default: background,
      paper,
    },
  },
  typography: {
    fontFamily: ['Source Sans Pro', 'sans-serif'].join(','),
  },

  components: {
    MuiTextField: { styleOverrides: {} },
    MuiButton: { styleOverrides: { root: { textTransform: 'capitalize', borderRadius: '6px' } } },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          '&::-webkit-scrollbar': {
            width: '8px',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#4288F0',
            borderRadius: 8,
          },
        },
      },
    },
  },
});
